import { createFileRoute, redirect } from "@tanstack/react-router";
import { DashboardLayout } from "@/features/dashboard/DashboardLayout";
import { requireBusinessDashboard } from "@/lib/auth-guard";
import { productFeatures } from "@/lib/product-features";

export const Route = createFileRoute("/dashboard")({
  beforeLoad: (args) => {
    const legacySalesPath = args.location.pathname.match(/^\/dashboard(?:\/([^/]+))?\/pos\/?$/);
    if (legacySalesPath && !productFeatures.sales) {
      const slug = legacySalesPath[1];
      if (slug) {
        throw redirect({
          to: "/dashboard/$businessSlug/calendar",
          params: { businessSlug: decodeURIComponent(slug) },
          search: {},
          replace: true,
        });
      }
      throw redirect({
        to: "/dashboard/calendar",
        search: {},
        replace: true,
      });
    }
    return requireBusinessDashboard(args);
  },
  component: DashboardLayout,
});
